<template>
  <div class="el-section">
    <div
      class="emd-container _highlight_header _header_spaced _footer_spaced_sm"
    >
      <div class="emd-container__header">
        <h2 class="emd-text _size_section">{{ $t('webhook.config.title') }}</h2>
        <router-link
          :to="{ name: 'webhook-config-form' }"
          tag="button"
          class="emd-btn _color_primary _size_small"
          v-if="isCreateWebhooksEnabled"
        >
          <i class="uil uil-plus" /> {{ $t('webhook.config.create-webhook') }}
        </router-link>
      </div>
      <div
        v-if="loadingList"
        class="eu-pa_6 eu-align_center"
      >
        <emd-loader :type="'_invert'"></emd-loader>
      </div>
      <div v-else>
        <div
          class="emd-card-grid"
          v-for="(webhookSetting, index) in webhookSettings.items"
          :key="index"
        >
          <div class="emd-card-grid__content">
            <div class="eu-clearfix">
              <div class="eu-float_left">
                <h2
                  class="emd-text _type_caption eu-pb_2 eu-pr_2 eu_no_padding_sm"
                >
                  {{ webhookSetting.url }}
                </h2>
              </div>
              <div class="eu-float_right">
                <router-link
                  :to="{
                    name: 'webhook-config-edit',
                    params: { id: webhookSetting.id }
                  }"
                  tag="button"
                  class="emd-btn-ghost"
                  v-if="isWebhooksEditEnabled"
                >
                  <i class="uil uil-pen" />
                </router-link>
              </div>
            </div>
          </div>
          <div class="emd-card-grid__row">
            <div class="emd-card-grid__column">
              <label class="emd-text _type_label _size_tiny _color_subtle">{{
                $t('webhook.config.id')
              }}</label>
              <p class="emd-card-grid__line">{{ webhookSetting.id }}</p>
            </div>
            <div class="emd-card-grid__column">
              <label class="emd-text _type_label _size_tiny _color_subtle">{{
                $t('webhook.config.status')
              }}</label>
              <p class="emd-card-grid__line">
                <span
                  class="emd-badge"
                  v-bind:class="statusClass(webhookSetting.status)"
                  >{{ webhookSetting.status }}</span
                >
              </p>
            </div>
            <div class="emd-card-grid__column">
              <label class="emd-text _type_label _size_tiny _color_subtle">{{
                $t('webhook.config.retries')
              }}</label>
              <p class="emd-card-grid__line">
                {{ webhookSetting.max_attempts }}
              </p>
            </div>
            <div class="emd-card-grid__column">
              <label class="emd-text _type_label _size_tiny _color_subtle">{{
                $t('webhook.config.send-disabled')
              }}</label>
              <p class="emd-card-grid__line">
                {{ webhookSetting.send_disabled }}
              </p>
            </div>
            <div class="emd-card-grid__column">
              <label class="emd-text _type_label _size_tiny _color_subtle">{{
                $t('webhook.config.created-at')
              }}</label>
              <p class="emd-card-grid__line">
                {{ webhookSetting.created_at | dateFormat('dateAndHour') }}
              </p>
            </div>
            <div class="emd-card-grid__column _size_100">
              <label class="emd-text _type_label _size_tiny _color_subtle">{{
                $t('webhook.config.events')
              }}</label>
              <div class="eu-pt_1">
                <ul class="emd-list _space_tiny _inline">
                  <li
                    v-for="(event, id) in webhookSetting.events"
                    :key="id"
                  >
                    <span class="emd-badge _stacked _color_info">{{
                      event
                    }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <empty-list
          class="eu-pb_3"
          v-if="showEmptyList()"
          entity="webhooks-config"
        ></empty-list>
        <pagination
          v-if="!loadingList"
          :pagination="webhookSettings.pagination"
          :totalShowing="totalItems"
          :type="'list'"
          :action="'GET_WEBHOOK_SETTINGS'"
        ></pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { EmdLoader } from 'emerald-vue/src/components'
import EmptyList from '@/components/project/globals/EmptyList.vue'
import { statusClass } from '@/filters'
import Pagination from '@/components/project/globals/Pagination.vue'
import { mapGetters } from 'vuex'
import {
  isSettingsWebhooksConfigEditEnabled,
  isSettingsWebhooksConfigCreateEnabled
} from '@/actions-permission/settings-webhooks-config.permission'

export default {
  name: 'WebhookConfig',
  components: {
    EmdLoader,
    EmptyList,
    Pagination
  },
  data () {
    return {
      statusClass: statusClass,
      query: {
        page: 1,
        size: 30
      }
    }
  },
  computed: {
    ...mapGetters([
      'merchant',
      'account',
      'loadingListWebhooksSettings',
      'webhookSettings',
      'permissionIsEnabled'
    ]),
    loadingList () {
      return this.loadingListWebhooksSettings
    },
    totalItems () {
      return this.webhookSettings.items.length
    },
    isCreateWebhooksEnabled () {
      return isSettingsWebhooksConfigCreateEnabled(this.permissionIsEnabled)
    },
    isWebhooksEditEnabled () {
      return isSettingsWebhooksConfigEditEnabled(this.permissionIsEnabled)
    }
  },
  methods: {
    getWebhookSettings () {
      const params = {
        merchantId: this.merchant.id,
        accountId: this.account.id,
        query: this.query
      }
      this.$store.dispatch('GET_WEBHOOK_SETTINGS', params).then(res => {
        this.$router.replace({ query: this.query }).catch(err => err)
      })
    },
    showEmptyList () {
      return (
        !this.loadingList &&
        this.webhookSettings.pagination &&
        this.webhookSettings.pagination.total_items === 0
      )
    }
  },
  beforeMount () {
    this.getWebhookSettings()
  }
}
</script>
